/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable */
// @ts-nocheck

import React, { useEffect, useState } from "react";
import { FormLabel } from "@carbon/react";
import ToggleField from "../inputs/ToggleField";
import NumberField from "../inputs/NumberField";
import TextField from "../inputs/TextField";
import TextAreaField from "../inputs/TextAreaField";
import Form from "../../ui/Form/Form";
import CopyButton from "../buttons/CopyButton";
import MappedValueDropdown from "../../ui/MappedValueDropdown";
import {
  BULK_UPLOAD_GENERAL_TRANSLATIONS,
  FORM_VALIDATION_TRANSLATIONS,
  SIDEPANEL_GENERAL_TRANSLATIONS,
} from "../../translations/util";
import DropdownField from "../inputs/DropdownField";
import { ADD_MCPTT_USER_MAPPED_FIELDS } from "../../constants/addFormFields";
import DragndropContainer from "../fileUpload/DragNdropContainer";
import FileUploaderItem from "../fileUpload/FileUploaderItem";
import { ReactComponent as Key } from "../../assets/icons/key.svg";
import Button, { Icons } from "../buttons/Button";
import FieldTooltip from "../tooltip/Tooltip";
import { downloadCertificate } from "../../util";

interface IProps {
  esRef: string;
  data: any;
  setData: any;
  isEditing: boolean;
  formFields: any;
  formModule?: string;
  newData?: object;
  setNewData?: any;
  openFileUpload?: boolean;
  setOpenFileUpload?: any;
}

const EditRowFormFields = ({
  esRef,
  data,
  setData,
  isEditing,
  formFields,
  formModule,
  newData,
  setNewData,
  openFileUpload,
  setOpenFileUpload,
}: IProps) => {
  const [fileName, setFileName] = useState("");
  const [dataLoading, setDataLoading] = useState("");
  const [fileType, setFileType] = useState("");

  const [certificateName, setCertificateName] = useState("");
  const [isCertificateInvalid, setIsCertificateInvalid] = useState(false);
  const [errorSubject, setErrorSubject] = useState("");

  const handleFileDelete = () => {
    setFileName("");
    setFileType("");
    setData({
      ...data,
      "IKI-CERTIFICATE": "",
      TYPE: undefined,
    });
    setIsCertificateInvalid(false);
  };

  // This function returns error subject based on conditions
  const handleErrorSubject = () => {
    let errorSubject = "";

    if (isCertificateInvalid) {
      errorSubject =
        BULK_UPLOAD_GENERAL_TRANSLATIONS.InvalidCertificateTypeText;
    }

    setErrorSubject(errorSubject);
  };

  const handleCertificateParsing = (file: any) => {
    let fileReader: FileReader;
    try {
      setDataLoading(true);
      fileReader = new FileReader();
      fileReader.readAsText(file);
      fileReader.onloadend = () => {
        const content: string | ArrayBuffer | null = fileReader.result;
        setData({
          ...data,
          "IKI-CERTIFICATE": content,
          TYPE: file.type,
        });
        return content;
      };
    } catch (error: any) {
      errorAlert(error);
    } finally {
      setDataLoading(false);
    }
  };

  const handleInvalidCertificate = () => {
    if (
      (fileType !== "application/x-x509-ca-cert" &&
        !fileName.endsWith(".pem")) ||
      (fileType !== "application/x-pem-file" && !fileName.endsWith(".pem"))
    ) {
      setIsCertificateInvalid(true);
    }
  };

  const getCertificateName = () => {
    if (
      data["IKI-CERTIFICATE"] !== null &&
      data["IKI-CERTIFICATE"] !== "" &&
      data["IKI-CERTIFICATE"] !== undefined
    ) {
      if (fileName.length > 0 && isEditing) {
        return "IKI-Certificate" + "_" + fileName;
      } else {
        return "IKI-Certificate" + "_" + data["IKI-NAME"];
      }
    }
    return "";
  };

  useEffect(() => {
    const name = getCertificateName();
    setCertificateName(name);
  }, [data, fileName]);

  useEffect(() => {
    if (fileName.length > 0) {
      handleInvalidCertificate();
    }
  }, [fileName]);

  useEffect(() => {
    if (isCertificateInvalid) {
      handleErrorSubject();
    }
  }, [isCertificateInvalid]);

  useEffect(() => {
    if (!openFileUpload) {
      setFileName("");
      setIsCertificateInvalid(false);
    }
  }, [openFileUpload]);

  return (
    <Form>
      <div className="readonly-data" data-cy="readonly-section">
        <ul>
          {formModule === "Organisation" ? (
            <li className="flex items-center" data-cy="orgID">
              <h5>
                {SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields["ORG-ID"]}
              </h5>
              <div className="data-content">
                <span> {data["ORG-ID"]} </span>
                <CopyButton copyContent={data["ORG-ID"]} copyField="ORG-ID" />
              </div>
            </li>
          ) : (
            <li className="flex items-center" data-cy="referenceID">
              <h5>
                {
                  SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields[
                    "Reference ID"
                  ]
                }
              </h5>
              <div className="data-content">
                <span
                  className={(data.Ref || esRef).length > 20 ? "truncate" : ""}
                >
                  {data.Ref || esRef}
                </span>
                <CopyButton
                  copyContent={data.Ref || esRef}
                  copyField="referenceID"
                />
              </div>
            </li>
          )}

          {data.type ? (
            <li className="flex items-center" data-cy="translationType">
              <h5>
                {
                  SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields[
                    "Translation Type"
                  ]
                }
              </h5>
              <div className="data-content">
                <span className={data.type.length > 20 ? "truncate" : ""}>
                  {data.type}
                </span>
                <CopyButton
                  copyContent={data.type}
                  copyField="translationType"
                />
              </div>
            </li>
          ) : null}

          <li className="flex items-center" data-cy="creationDate">
            {data.CreationDate ? (
              <div className="flex items-center mr-3">
                <h5>
                  {
                    SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields
                      .CreationDate
                  }
                </h5>
                <div className="data-content">
                  <span> {data.CreationDate} </span>
                </div>
              </div>
            ) : null}

            {data.ModificationDate && (
              <div className="flex items-center" data-cy="modificationDate">
                <h5>
                  {
                    SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields
                      .ModificationDate
                  }
                </h5>
                <div className="data-content">
                  <span> {data.ModificationDate} </span>
                </div>
              </div>
            )}
          </li>

          {data["CONNECTION-ID"] ? (
            <li className="flex items-center " data-cy="connectionID">
              <h5>
                {
                  SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields[
                    "CONNECTION-ID"
                  ]
                }
              </h5>
              <div className="data-content">
                <span> {data["CONNECTION-ID"]} </span>
                <CopyButton
                  copyContent={data["CONNECTION-ID"]}
                  copyField="connectionID"
                />
              </div>
            </li>
          ) : null}

          {data["DFSI-UNIT-CONTROL-ATTEMPT-LIMIT"] ? (
            <li
              className="flex items-center "
              data-cy="dfsiUnitControlAttemptLimit"
            >
              <h5>
                {
                  SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields[
                    "DFSI-UNIT-CONTROL-ATTEMPT-LIMIT"
                  ]
                }
              </h5>
              <div className="data-content">
                <span> {data["DFSI-UNIT-CONTROL-ATTEMPT-LIMIT"]} </span>
              </div>
            </li>
          ) : null}

          {data["DFSI-UNIT-CONTROL-RETRY-TIME"] ? (
            <li
              className="flex items-center "
              data-cy="dfsiUnitControlRetyrTime"
            >
              <h5>
                {
                  SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields[
                    "DFSI-UNIT-CONTROL-RETRY-TIME"
                  ]
                }
              </h5>
              <div className="data-content">
                <span> {data["DFSI-UNIT-CONTROL-RETRY-TIME"]} </span>
              </div>
            </li>
          ) : null}

          {data["MCPTT-ID"] ? (
            <li className="flex items-center " data-cy="MCPTT-ID">
              <h5>
                {SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields["MCPTT-ID"]}
              </h5>
              <div className="data-content">
                <span> {data["MCPTT-ID"]} </span>
                <CopyButton
                  copyContent={data["MCPTT-ID"]}
                  copyField="MCPTT-ID"
                />
              </div>
            </li>
          ) : null}

          {data["DFSI-VERSION"] ? (
            <li className="flex items-center " data-cy="DFSI-VERSION">
              <h5>
                {
                  SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields[
                    "DFSI-VERSION"
                  ]
                }
              </h5>
              <div className="data-content">
                <span> {data["DFSI-VERSION"]} </span>
                <CopyButton
                  copyContent={data["DFSI-VERSION"]}
                  copyField="DFSI-VERSION"
                />
              </div>
            </li>
          ) : null}

          {data["LMR-ID"] ? (
            <li className="flex items-center " data-cy="LMR-ID">
              <h5>
                {SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields["LMR-ID"]}
              </h5>
              <div className="data-content">
                <span> {data["LMR-ID"]} </span>
                <CopyButton copyContent={data["LMR-ID"]} copyField="LMR-ID" />
              </div>
            </li>
          ) : null}

          {data["MSG-ID"] ? (
            <li className="flex items-center " data-cy="MSG-ID">
              <h5>
                {SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields["MSG-ID"]}
              </h5>
              <div className="data-content">
                <span> {data["MSG-ID"]} </span>
                <CopyButton copyContent={data["MSG-ID"]} copyField="MSG-ID" />
              </div>
            </li>
          ) : null}
          {data["TG-ID"] ? (
            <li className="flex items-center " data-cy="TG-ID">
              <h5>
                {SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields["TG-ID"]}
              </h5>
              <div className="data-content">
                <span> {data["TG-ID"]} </span>
                <CopyButton copyContent={data["TG-ID"]} copyField="TG-ID" />
              </div>
            </li>
          ) : null}
          {data["MCPTT-GID"] ? (
            <li className="flex items-center " data-cy="MCPTT-GID">
              <h5>
                {SIDEPANEL_GENERAL_TRANSLATIONS.nonEditableFields["MCPTT-GID"]}
              </h5>
              <div className="data-content">
                <span> {data["MCPTT-GID"]} </span>
                <CopyButton
                  copyContent={data["MCPTT-GID"]}
                  copyField="MCPTT-GID"
                />
              </div>
            </li>
          ) : null}
        </ul>
      </div>

      {formFields.map(
        (rows: {
          cols: number;
          fields: {
            name: string;
            tooltipText?: string;
            label: string;
            type: string;
            invalidText?: string | null;
            isInputInvalid?: (val?: string | string[], data?: any) => boolean;
            min?: number;
            max?: number;
            disabled?: boolean;
            required?: boolean;
            items?: string[] | undefined;
            placeholder?: string[] | undefined;
            dropdownDisabled?: boolean;
          }[];
        }) => {
          return (
            <div className={`grid grid-cols-${rows.cols} gap-4 form-control`}>
              {rows.fields.map((field) => {
                switch (field.type) {
                  case "TOGGLE":
                    return (
                      <ToggleField
                        labelText={field.label}
                        onChange={(val) => {
                          if (formModule === "LMR User") {
                            setNewData({ ...newData, [field.name]: val });
                          }
                          setData({
                            ...data,
                            [field.name]: val,
                          });
                        }}
                        disabled={!isEditing}
                        value={data[field.name] as boolean}
                        tooltipText={field.tooltipText}
                      />
                    );
                  case "DROPDOWN":
                    return (
                      <DropdownField
                        className="dropdown-field"
                        label={field.label}
                        selectedItem={data[field.name]}
                        items={field.items || []}
                        onChange={({
                          selectedItem,
                        }: {
                          selectedItem: string;
                        }) =>
                          setData({
                            ...data,
                            [field.name]: selectedItem,
                          })
                        }
                        tooltipText={field.tooltipText}
                        required
                        disabled
                      />
                    );
                  case "MCUser_DROPDOWN":
                    return (
                      <>
                        <DropdownField
                          className="dropdown-field"
                          label={field.label}
                          selectedItem={data[field.name]}
                          items={field.items ?? []}
                          onChange={({
                            selectedItem,
                          }: {
                            selectedItem: string;
                          }) => {
                            const prevMappedField =
                              data["SELECTED-MAPPED-FIELD"];
                            if (prevMappedField.includes("+")) {
                              const result = prevMappedField.split("+");
                              setData({
                                ...data,
                                [result[0].trim()]: "",
                                [result[1].trim()]: "",
                                "SELECTED-MAPPED-FIELD": selectedItem,
                              });
                            } else {
                              setData({
                                ...data,
                                [prevMappedField]: "",
                                "SELECTED-MAPPED-FIELD": selectedItem,
                              });
                            }
                          }}
                          tooltipText={field.tooltipText}
                          required
                          disabled={!isEditing}
                        />
                        {data[field.name]
                          ? data[field.name]
                              .split("+")
                              .map((mappedField: string) =>
                                ADD_MCPTT_USER_MAPPED_FIELDS.filter(
                                  (field: {
                                    name: string;
                                    tooltipText?: string;
                                    label: string;
                                    invalidText?: string | null;
                                    isInputInvalid?: (
                                      val?: string | string[],
                                      data?: any
                                    ) => boolean;
                                  }) => field.name === mappedField.trim()
                                )
                              )
                              .flat(1)
                              .map(
                                (field: {
                                  name: string;
                                  tooltipText?: string;
                                  label: string;
                                  invalidText?: string | null;
                                  isInputInvalid?: (
                                    val?: string | string[],
                                    data?: any
                                  ) => boolean;
                                }) => {
                                  return (
                                    <TextField
                                      onChange={(val) => {
                                        setData({
                                          ...data,
                                          [field.name]: val,
                                        });
                                      }}
                                      placeholder={field?.label}
                                      value={
                                        data[field.name] === null
                                          ? ""
                                          : (data[field.name] as string)
                                      }
                                      invalid={field.isInputInvalid?.(
                                        data[field.name] as string
                                      )}
                                      invalidText={
                                        field.invalidText ||
                                        FORM_VALIDATION_TRANSLATIONS.required(
                                          field.label
                                        )
                                      }
                                      labelText={field?.label}
                                      tooltipText={field.tooltipText}
                                      disabled={!isEditing}
                                    />
                                  );
                                }
                              )
                          : null}
                      </>
                    );
                  case "NUMBER":
                    return (
                      <NumberField
                        onChange={(val) => {
                          if (!val || !Number.isNaN(+val))
                            setData({
                              ...data,
                              [field.name]: val ? +val : undefined,
                            });
                        }}
                        disabled={!isEditing}
                        label={field.label}
                        placeholder={field.label}
                        max={field.max || 0}
                        min={field.min || 0}
                        invalid={
                          !isEditing
                            ? false
                            : data[field.name] !== 0 && !data[field.name]
                        }
                        invalidText={
                          field.invalidText ||
                          `"${field.label}" ${FORM_VALIDATION_TRANSLATIONS.range} (${field.min}-${field.max})`
                        }
                        value={data[field.name] as number}
                        tooltipText={field.tooltipText}
                        required
                      />
                    );
                  case "TEXTAREA":
                    return (
                      <TextAreaField
                        onChange={(val) =>
                          setData({
                            ...data,
                            [field.name]: val,
                          })
                        }
                        placeholder={field.label}
                        value={data[field.name] as string}
                        invalid={
                          !isEditing
                            ? false
                            : field.isInputInvalid?.(data[field.name])
                        }
                        invalidText={
                          field.invalidText ||
                          FORM_VALIDATION_TRANSLATIONS.required(field.label)
                        }
                        labelText={field.label}
                        tooltipText={field.tooltipText}
                        disabled={!isEditing}
                        required
                      />
                    );
                  case "MappedValueDropdown":
                    return (
                      <MappedValueDropdown
                        onChange={(val: any) =>
                          field.items &&
                          setData({
                            ...data,
                            [field.items.filter(
                              (key) => data[key] !== null
                            )[0]]: val,
                          })
                        }
                        currentItem={
                          field.items &&
                          field.items.filter((key) => data[key] !== null)[0]
                        }
                        value={
                          field.items &&
                          data[
                            field.items.filter((key) => data[key] !== null)[0]
                          ]
                        }
                        items={field.items}
                        placeholder={field.placeholder}
                        invalid={
                          field.items &&
                          field.isInputInvalid?.(
                            data[
                              field.items.filter((key) => data[key] !== null)[0]
                            ]
                          )
                        }
                        invalidText={
                          field.invalidText ||
                          (field.items &&
                            FORM_VALIDATION_TRANSLATIONS.required(
                              field.items.filter((key) => data[key] !== null)[0]
                            ))
                        }
                        label={field.label}
                        tooltipText={field.tooltipText}
                        disabled={!isEditing}
                        dropdownDisabled={field.dropdownDisabled}
                        required
                      />
                    );
                  case "FILE":
                    return (
                      <>
                        <div className="bulk-upload-iconbutton flex">
                          <div className="form-wrapper">
                            <div className="form-label" data-cy="textFieldForm">
                              <FormLabel
                                data-cy={`${field.label.replaceAll(
                                  " ",
                                  ""
                                )}-textlabel`}
                              >
                                Certificate :{" "}
                                <button
                                  type="button"
                                  className="ml-1 download-text"
                                  onClick={() =>
                                    downloadCertificate(
                                      data[field.name],
                                      data["IKI-NAME"]
                                    )
                                  }
                                  data-cy="download-certificate"
                                >
                                  {certificateName}
                                </button>
                              </FormLabel>
                            </div>
                          </div>
                          <Button
                            kind="ghost"
                            className="bg-btn ml-2"
                            hasIconOnly
                            dataCy="updateIKIcertificate-"
                            icon={Icons.Edit}
                            iconDescription="Update IKI Certificate"
                            onClick={() => setOpenFileUpload(true)}
                            disabled={!isEditing || certificateName.length <= 0}
                          />
                        </div>
                        {openFileUpload ? (
                          <div className=" bulk-upload-card">
                            <h4
                              className="import-tab-title"
                              data-cy="tab-title"
                            >
                              Upload New IKI Certificate
                            </h4>
                            <div
                              className="dragndrop-container"
                              data-cy="dragndrop-container"
                            >
                              <DragndropContainer
                                labelText={field.label}
                                filenameStatus={
                                  dataLoading ? "uploading" : "edit"
                                }
                                onAddFiles={(fileData) => {
                                  handleCertificateParsing(fileData);
                                  setFileName(fileData.name);
                                  setFileType(fileData.type);
                                }}
                                disabled={
                                  !isEditing ||
                                  (isEditing && fileName.length > 0)
                                }
                              />
                            </div>
                            {fileName ? (
                              <div className="file-block flex items-center justify-between">
                                <div className="flex items-center">
                                  <div className="certificate-svg">
                                    <Key />
                                  </div>
                                  <FileUploaderItem
                                    name={BULK_UPLOAD_GENERAL_TRANSLATIONS.ImportTab.handleFileUpoadtext(
                                      fileName
                                    )}
                                    data-cy="file-uploader-item"
                                    status={dataLoading ? "uploading" : "edit"}
                                    onDelete={handleFileDelete}
                                    invalid={isCertificateInvalid}
                                    errorSubject={errorSubject}
                                  />
                                </div>
                              </div>
                            ) : null}
                          </div>
                        ) : null}
                      </>
                    );
                  default:
                    return (
                      <TextField
                        onChange={(val) => {
                          if (
                            (formModule === "LMR Group" &&
                              field.name === "LMR-NW-TYPE") ||
                            field.name === "MAPPED-MCPTT-GID"
                          ) {
                            setNewData({ ...newData, [field.name]: val });
                          }
                          if (formModule === "LMR User") {
                            setNewData({ ...newData, [field.name]: val });
                          }
                          setData({
                            ...data,
                            [field.name]: val,
                          });
                        }}
                        disabled={!isEditing || field.disabled}
                        placeholder={field.label}
                        value={
                          data[field.name] ? (data[field.name] as string) : ""
                        }
                        invalid={
                          !isEditing
                            ? false
                            : field.isInputInvalid?.(data[field.name])
                        }
                        invalidText={
                          field.invalidText ||
                          FORM_VALIDATION_TRANSLATIONS.required(field.label)
                        }
                        labelText={field.label}
                        tooltipText={field.tooltipText}
                        required={
                          field.required === undefined ||
                          field.required === true
                        }
                      />
                    );
                }
              })}
            </div>
          );
        }
      )}
    </Form>
  );
};

export default EditRowFormFields;
